import React from "react"

import { TypeformRegistrationContext } from "./src/services/typeformRegistration"

export const wrapRootElement = ({ element }) => (
  <TypeformRegistrationContext>{element}</TypeformRegistrationContext>
)